import React from "react";
import {observer} from "mobx-react";
import './modal.scss'
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import {WarningIcon} from "../../assets/svg-icons/WarningIcon";

const CancelPayPerClickModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    function closeModal() {
        modalStore.isCancelPayPerClickModalOpen = false;
        modalStore.resetModalData();
    }

    async function cancelPayPerClick() {
        try {
            await modalStore.modalData.onConfirm()
            closeModal()
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('problemCancelingPayPerClickOption'));
            console.error(e);
        }
        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isCancelPayPerClickModalOpen'
            className='open-style-dialog delete-open-style'
            onEnter={null}
            title={<><WarningIcon/><h2>{modalStore.modalData.title}</h2></>}
            body={<div className="dialog-description">{modalStore.modalData.message}</div>}
            isConfirmDisabled={false}
            onConfirm={cancelPayPerClick}
            confirmText={generalStore.translate('stopPermission')}
            buttonClass={'warning'}
        />
    );
});

export default CancelPayPerClickModal;
